/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/manage.scss';
import Tab from '../../component/Inc/Tab';
import PopManageGrade from './_PopManageGrade';
function Class() {
  const [tabIdx, setTabIdx] = useState(0);
  const [modalGrade, setModalGrade] = useState(false);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '과탐', value: 3},
    {title: '사탐', value: 4}
  ];
  return (
    <main className="com_container p_manage_class">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_7">상품 관리</h2>
          <div className="com_btn_wrap">
            <button
              onClick={() => {
                setModalGrade(true);
              }}
              className="com_btn orange s btn_plus"
            >
              학년 관리
            </button>
          </div>
        </section>
        <section className="com_pg_container">
				{/*20250218 퍼블 수정*/}
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <span className="com_check_box">
                <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                <label htmlFor="chk010">미판매</label>
              </span>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo_1" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">전체</label>
                  <input type="radio" name="rdo_1" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">수학</label>
                  <input type="radio" name="rdo_1" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">수학2</label>
                </div>
              </div>
            </div>

            <table className="com_board_list">
              <colgroup>
                <col width="50" />
                <col width="110" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="auto" />
                <col width="180" />
                <col width="180" />
              </colgroup>
              <thead>
                <tr>
                  <th rowSpan={2}>
                    <input type="checkbox" name="chk" id="chk00" className="com_chk" />
                    <label htmlFor="chk00"></label>
                  </th>
                  <th rowSpan={2}>학년</th>
                  <th colSpan={6}>4회당 금액(원)</th>
                  <th rowSpan={2}>지점</th>
                  <th rowSpan={2}>상태</th>
                  <th rowSpan={2}>
                    보고서 
                    유무
                  </th>
                </tr>
                <tr>
                  <th className="border_left">30분</th>
                  <th>60분</th>
                  <th>90분</th>
                  <th>120분</th>
                  <th>150분</th>
                  <th>180분</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td className="bg">
                    <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                    <label htmlFor="chk01"></label>
                  </td>
                  <td className="bg">
                    <select name="" id="" className="select">
                      <option value="중1 이하">중1 이하</option>
                    </select>
                  </td>
                  <td>
                    <input type="text" className="input " defaultValue={`230,000`} />
                  </td>
                  <td>230,000</td>
                  <td>230,000</td>
                  <td>230,000</td>
                  <td>230,000</td>
                  <td>230,000</td>
                  <td>
                    <div className="check radio_wrap">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">본사</label>
                      <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                      <label htmlFor="chk02">부산</label>
                      <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                      <label htmlFor="chk03">원격과세</label>
                      <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                      <label htmlFor="chk04">원격비과세</label>
                    </div>
                  </td>
                  <td>
                    <div className="check radio_wrap">
                      <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                      <label htmlFor="rdo2_1">판매 </label>
                      <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                      <label htmlFor="rdo2_2">미판매</label>
                    </div>
                  </td>
                  <td>
                    <div className="check radio_wrap">
                      <input type="radio" name="rdo_3" id="rdo3_1" className="com_chk circle" />
                      <label htmlFor="rdo3_1"> 유 </label>
                      <input type="radio" name="rdo_3" id="rdo3_2" className="com_chk circle" />
                      <label htmlFor="rdo3_2">무</label>
                    </div>
                  </td>
                </tr>
                {[...Array(6)].map((i, idx) => (
                  <tr key={idx}>
                    <td className="bg">
                      <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                      <label htmlFor="chk01"></label>
                    </td>
                    <td className="bg">중2 이하</td>
                    <td>230,000</td>
                    <td>230,000</td>
                    <td>230,000</td>
                    <td>230,000</td>
                    <td>230,000</td>
                    <td>230,000</td>
                    <td>
                      <div className="check radio_wrap">
                        <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                        <label htmlFor="chk01">본사</label>
                        <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                        <label htmlFor="chk02">부산</label>
                        <input type="checkbox" name="chk" id="chk03" className="com_chk" />
                        <label htmlFor="chk03">원격과세</label>
                        <input type="checkbox" name="chk" id="chk04" className="com_chk" />
                        <label htmlFor="chk04">원격비과세</label>
                      </div>
                    </td>
                    <td>
                      <div className="check radio_wrap">
                        <input type="radio" name="rdo_2" id="rdo2_1" className="com_chk circle" />
                        <label htmlFor="rdo2_1">판매 </label>
                        <input type="radio" name="rdo_2" id="rdo2_2" className="com_chk circle" />
                        <label htmlFor="rdo2_2">미판매</label>
                      </div>
                    </td>
                    <td>
                      <div className="check radio_wrap">
                        <input type="radio" name="rdo_3" id="rdo3_1" className="com_chk circle" />
                        <label htmlFor="rdo3_1"> 유 </label>
                        <input type="radio" name="rdo_3" id="rdo3_2" className="com_chk circle" />
                        <label htmlFor="rdo3_2">무</label>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">수정</button>
            </div>
            <div className="com_board_list__bottom">
              <div className="com_btn_wrap left">
                <button className="com_btn black xs btn_plus_orange">항목 추가</button>
                <button className="com_btn black xs">선택 항목 삭제</button>
              </div>
            </div>
          </section>
          <section className="box full">
            <div className="com_board_list__top">
              <div className="detail_tit dot">배정 제한된 교사 목록</div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="교사명 검색" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>

                  <button className="com_btn orange s">등록</button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="490" />
                <col width="490" />
                <col width="490" />
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                    <label htmlFor="chkAll"></label>
                  </th>
                  <th>제한일</th>
                  <th>교사명</th>
                  <th>과목</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(3)].map((_, idx) => (
                  <tr key={idx}>
                    <td>
                      <input type="checkbox" name="chk" id="chk00" className="com_chk" />
                      <label htmlFor="chk00"></label>
                    </td>
                    <td>2023, 05, 12</td>
                    <td>김교사 103</td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="com_btn_wrap bottom">
              <button className="com_btn black xs">선택한 항목 교사 배정 제한 취소</button>
            </div>
          </section>
        </section>
      </div>
      <PopManageGrade open={modalGrade} close={() => setModalGrade(false)} />
    </main>
  );
}

export default Class;
